import styled, { css } from "styled-components";

const Container = styled.div`
  border-radius: 8px;
  width: 100%;
  aspect-ratio: 1/1.1;
  padding: 12px;
  background-color: ${(props) => props.theme.color.background.tertiary};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
  ${(props) =>
    props.selected &&
    css`
      border: 1px solid white;
    `}
`;

const Icon = styled.img`
  width: 60px;
  height: 60px;
  pointer-events: none;
`;

const Name = styled.label`
  margin-top: 8px;
  font-size: ${(props) => props.theme.font.size.small};
  font-weight: 600;
  display: block;
  display: -webkit-box;
  height: 1.3em;
  line-height: 1.3em;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.theme.color.text.primary};
  ${(props) =>
    props.disabled &&
    css`
      color: #787878;
    `}
`;

export { Container, Icon, Name };
